import {
  Button,
  Dialog,
  DialogBody,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  LinkIcon,
  LockFileIcon,
  UserAddIcon,
} from "@theprelude/ds";
import { z } from "zod";
import { useOverlay } from "@/hooks/use-overlay";
import { tb } from "@/lib/tracking";

export const newAccountSchema = z.tuple([z.literal("new-account")]);

export const NewAccountConfirmation = () => {
  const overlay = useOverlay();
  return (
    <Dialog
      onOpenChange={(value) => {
        if (!value) {
          void overlay.close();
        }
      }}
      defaultOpen
    >
      <DialogContent disableImplicitClose>
        <DialogHeader>
          <DialogTitle>Welcome to Prelude</DialogTitle>
        </DialogHeader>
        <DialogBody>
          <p className="mb-2 flex items-start gap-3">
            <LinkIcon className="mt-1 size-5 shrink-0 fill-primary-foreground" />
            Please check your email for a link to activate your account.
          </p>
          <p className="mb-2 flex items-start gap-3">
            <LockFileIcon className="mt-1 size-5 shrink-0 fill-primary-foreground" />
            Keep your credentials somewhere safe to log back in from a different
            device.
          </p>
          <p className="mb-2 flex items-start gap-3">
            <UserAddIcon className="mt-1 size-5 shrink-0 fill-primary-foreground" />
            Invite your teammates under Account Settings in the nav bar.
          </p>
        </DialogBody>
        <DialogFooter>
          <DialogClose asChild>
            <Button intent="secondary" className={tb("got-it")}>
              Got it
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
